import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'booleanNullDisplay'
})
export class BooleanNullDisplayPipe implements PipeTransform {
    transform(value: any): string {
      if (value === true) return 'Yes';
      if (value === false) return 'No';
      if (value === null || value === undefined || value === "NULL") return '';
      return value;
    }
  }